import React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Toolbar from '@material-ui/core/Toolbar';
import { withStyles } from '@material-ui/core/styles';
import UserMenu from '../components/UserMenu'
import { connect } from 'react-redux'
import { withRouter } from "react-router-dom";  

const lightColor = 'rgba(255, 255, 255, 0.7)';

const styles = theme => ({
  secondaryBar: {
    zIndex: 0,
  },
  menuButton: {
    marginLeft: -theme.spacing(1),
  },
  iconButtonAvatar: {
    padding: 4,
  },
  appBar: {
    backgroundColor: '#232f3e',
  },
  link: {
    textDecoration: 'none',
    color: lightColor,
    '&:hover': {
      color: theme.palette.common.white,
    },
  },
  button: {
    borderColor: lightColor,
  },
  userName: {
    paddingRight: 10, // keep right padding when drawer closed
  }
});

const pageNames = {
  "": "Dashboard",
  "accounts": "Accounts",
  "transactions": "Transactions",
  "accountdetail": "Account Detail",
  "networth": "Net Worth",
  "budget": "Budget",
}

function Header(props) {
  const { classes, onDrawerToggle } = props;
  const { user } = props
  const path = props.location.pathname.split('/')[1];
  //const pathCapitalized = path.charAt(0).toUpperCase() + path.slice(1)
  const pathCapitalized = pageNames[path]

  return (
    <React.Fragment>
    <Hidden mdUp>
      <AppBar className={classes.appBar} position="sticky" elevation={0}>
        <Toolbar>
          <Grid container spacing={1} alignItems="center">
            
              <Grid item>
                <IconButton
                  color="inherit"
                  aria-label="Open drawer"
                  onClick={onDrawerToggle}
                  className={classes.menuButton}
                >
                  <MenuIcon />
                </IconButton>
              </Grid>
            
            <Grid item>
              {pathCapitalized}
            </Grid>
            <Grid item xs />
            <Grid item>
              {user && <UserMenu user={user} /> }
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
      </Hidden>
    </React.Fragment>
  );
}

Header.propTypes = {
  classes: PropTypes.object.isRequired,
  onDrawerToggle: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
  return {
    user: state.user,
  };
};

export default connect(mapStateToProps)(withStyles(styles)(withRouter(Header)));